<template>
  <div class="enroll_info">
    <div class="g-box">
      <div class="top-bg">
        <img width="1200px" src="../assets/img/jc.png" alt="" />
      </div>
      <div class="jc-form">
        <div class="tt">录取查询系统</div>
        <div class="form-input">
          <el-input
            style="width: 340px;"
            v-model.trim="idCardNo"
            clearable
            placeholder="请输入身份证"
          />
        </div>
        <div @click="search" class="form-btn">查 询</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Message } from "element-ui";
export default {
  data() {
    return {
      idCardNo: ""
    };
  },
  components: {
    "el-input": Input
  },
  mounted() {
    // this.removeFavicon();
    document.title = "录取查询";
    const link = document.querySelector('link[rel~="icon"]');
    if (link) {
      link.href = "";
    }
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = "data:,";
    document.head.appendChild(newLink);
  },
  methods: {
    removeFavicon() {
      // 获取head标签中所有的link元素
      var links = document.getElementsByTagName("link");
      // 遍历所有的link元素
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute("rel") === "icon") {
          console.log(links[i], "linkid");
          // 移除该link元素
          links[i].parentNode.removeChild(links[i]);
        }
      }
    },
    search() {
      if (!this.idCardNo) return Message.error("请先输入身份证后查询");
      this.$api.ems.education.schoolRollContinue_searchEnrollInfo
        .get({
          idCardNo: this.idCardNo,
          siteId: "1783772064219987969"
        })
        .then(res => {
          if (!res.data) return Message.warning("暂无录取信息~");
          this.$router.push({
            path: "/enroll_detail",
            query: {
              idCardNo: this.idCardNo
            }
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
.enroll_info {
  .jc-form {
    padding-top: 30px;
    .tt {
      font-family: Source Han Sans CN;
      font-size: 24px;
      font-weight: bold;
      color: #3d3d3d;
      text-align: center;
    }
    .form-input {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      .ipt {
        padding: 14px 16px;
        width: 340px;
        height: 46px;
        border-radius: 4px;
        box-sizing: border-box;
        border: 1px solid #eee;
      }
    }
    .form-btn {
      margin: 40px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      width: 340px;
      height: 48px;
      border-radius: 4px;
      background: #8f000a;
    }
  }
}
</style>
